import { motion } from "framer-motion";
import { Fuel, CarFront, Fence, Mountain, Hospital } from "lucide-react";

const icons = [Fuel, CarFront, Fence, Mountain, Hospital];

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
});

export const UseCases = ({ t }) => (
  <section id="use-cases" className="mx-auto max-w-[1440px] px-5 py-28 md:px-10 md:py-40" data-testid="usecases-section">
    <motion.p {...reveal()} className="mb-6 font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]" data-testid="usecases-kicker">
      / {t.kicker}
    </motion.p>
    <motion.h2 {...reveal()} className="max-w-3xl font-display text-3xl font-semibold tracking-tight md:text-5xl" data-testid="usecases-title">
      {t.title}
    </motion.h2>

    <div className="mt-16 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {t.blocks.map((b, i) => {
        const Icon = icons[i % icons.length];
        return (
          <motion.article
            key={b.title}
            {...reveal(i * 0.07)}
            className={`group clipped-frame relative flex flex-col justify-end overflow-hidden transition-transform duration-500 hover:-translate-y-1.5 ${
              b.big ? "min-h-[420px] md:col-span-2 lg:row-span-2 lg:min-h-full" : "min-h-[300px]"
            }`}
            data-testid={`usecase-${i}`}
          >
            {b.img ? (
              <>
                <img
                  src={b.img}
                  alt={b.title}
                  className="absolute inset-0 h-full w-full object-cover opacity-70 transition-all duration-700 group-hover:scale-[1.05] group-hover:opacity-90"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/40 to-transparent" />
              </>
            ) : (
              <div className="bg-grid absolute inset-0 bg-[#081226]" />
            )}
            <div className="relative z-10 p-7 md:p-9">
              <Icon className="mb-5 h-6 w-6 text-[#00e5ff]" strokeWidth={1.5} />
              <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-slate-50 md:text-xl">{b.title}</h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">{b.body}</p>
            </div>
          </motion.article>
        );
      })}
    </div>
  </section>
);
